import { GridSelectionModel } from '@mui/x-data-grid-pro';
import {useCallback, useState} from 'react';

interface RememberSelectionModelProps<TRowElement> {
  isSelectedEqualToItem: (selected: TRowElement, item: TRowElement) => boolean;
  selectionModel? : GridSelectionModel;
}

export function useRememberSelectionModel<TRowElement extends { [key: string]: any }>({ isSelectedEqualToItem, selectionModel: selection }: RememberSelectionModelProps<TRowElement>) {
  const [selectionModel, setSelectionModel] = useState<GridSelectionModel>(selection ?? []);
  const [rememberedSelectedValue, setRememberedSelectedValue] = useState<Set<TRowElement>>(new Set());
  const [isSelected, setIsSelected] = useState(false);

  const resetSelectionModel = useCallback(() => {
    setSelectionModel([]);
    setRememberedSelectedValue(new Set());
  }, []);


  const syncRememberedSelections = useCallback((rows: TRowElement[]) => {
    let selections: GridSelectionModel = [];
    rememberedSelectedValue.forEach((sel) => {
      if (rows.some((o) => isSelectedEqualToItem(sel, o))) {
        selections.push(sel.id);
      }
    });
    setSelectionModel(selections);
    setIsSelected(rememberedSelectedValue.size > 0);
  }, [isSelectedEqualToItem, rememberedSelectedValue]);
  const returnSelectionRememberModel:() => GridSelectionModel = useCallback(() =>{
    let selections: GridSelectionModel = [];
    rememberedSelectedValue.forEach((sel) => {
      selections.push(sel.id);
    });
    return selections;
  },[rememberedSelectedValue]);


  return {
    returnSelectionRememberModel,
    syncRememberedSelections,
    resetSelectionModel,
    selectionModel,
    setSelectionModel,
    rememberedSelectedValue,
    setRememberedSelectedValue,
    isSelected,
    setIsSelected
  };
}
